export const CHECKOUT_I18N_NAMESPACE = '@mc/checkout'
